'use client';

import { FC } from 'react';
import classNames from 'classnames';
import style from './progressbar.module.scss';

interface ProgressBarProps {
  progress: number; // 0-100
  className?: string;
  showPercentage?: boolean;
  text?: string;
}

const ProgressBar: FC<ProgressBarProps> = ({
  progress,
  className,
  showPercentage = true,
  text,
}) => {
  const isComplete = progress >= 100;

  return (
    <div className={classNames(style.progress_container, className)}>
      {(text || showPercentage) && (
        <div className={style.progress_message}>
          {text && <p>{text}</p>}
          {showPercentage && (
            <p className={style.progress_percentage}>
              {isComplete ? '100' : Math.round(progress)}%
            </p>
          )}
        </div>
      )}
      <div className={style.progress_wrapper}>
        <progress
          className={classNames(style.progress_bar, {
            [style.progress_bar_complete]: isComplete,
          })}
          max="100"
          value={progress}
        />
      </div>
    </div>
  );
};

export { ProgressBar };
